import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ReviewResultsSet from "./ReviewResultsSet";
import ReviewInSet from "./ReviewInSet";

import getBazaarProductReviews from "../../utilities/getBazaarProductReviews";

export default function SlideWithReviewCard({ data }) {
  const [results, setResults] = useState(null);
  const [formattedResults, setFormattedResults] = useState(null);

  useEffect(() => {
    const bazaarVoiceMetaField = data.shopifyProductData.metafields.find(
      (field) => field.key === "extId" && field.namespace === "bazaar_voice"
    );
    const bazaarVoiceId = bazaarVoiceMetaField && bazaarVoiceMetaField.value;
    if (bazaarVoiceId) {
      getBazaarProductReviews(bazaarVoiceId)
        .then((response) => response.json())
        .then((response) => {
          setResults(response.Results);
          // Slide is styled to display three 'review' cards per slide
          // If returned reviews are less then or equal to three return current array
          if (response.Results.length <= 3) {
            setFormattedResults([response.Results]);
          } else {
            // If returned reviews are greater then 3...
            // create a new array housed with arrays of three reviews each
            let arrayFormatted = [];
            let cardsPerItem = 3;
            let arrayOfReviews = response.Results;
            // If review is empty, remove review from array
            for (var i = 0; i < arrayOfReviews.length; i++) {
              var individualResult = arrayOfReviews[i];
              if (individualResult["IsRatingsOnly"]) {
                arrayOfReviews.splice(i, 1);
              }
            }
            for (var i = 0; i < arrayOfReviews.length; i += cardsPerItem) {
              arrayFormatted.push(arrayOfReviews.slice(i, cardsPerItem + i));
            }

            setFormattedResults(arrayFormatted);
          }
        });
    }
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: "slick-dots review-indicator",
  };
  return (
    <>
      <div className="block lg:hidden">
        <Slider
          {...settings}
          customPaging={(i) => {
            return <div className="w-8 h-2" />;
          }}
        >
          {results &&
            results.map((r, i) => (
              <ReviewInSet review={r} key={`Review${r.id}${i}`} />
            ))}
        </Slider>
      </div>
      <div className="hidden lg:block">
        <Slider
          {...settings}
          customPaging={(i) => {
            return <div className="w-12 h-2" />;
          }}
        >
          {formattedResults &&
            formattedResults.map((r, i) => (
              <ReviewResultsSet reviews={r} key={i} />
            ))}
        </Slider>
      </div>
    </>
  );
}
